'use es6';

import Actions from 'AdsUI/lib/Actions';
import { wrapReduxAction } from 'AdsUI/lib/ActionWrapper';
import AdWordsCampaignEntityData from 'AdsUI/data/AdWordsCampaignEntityData';
import { dispatchResetState } from 'AdsUI/actions/CampaignListActions';
import { AdWordsStatusMap } from 'AdsUI/lib/Constants';
import { adWordsCampaignEntityTransform } from 'AdsUI/lib/Transforms';
export default {
  removeCampaign(accountId, campaignId) {
    const opts = {
      entityStatus: AdWordsStatusMap.REMOVED,
      id: campaignId,
      accountId
    };
    return function (dispatch) {
      wrapReduxAction(AdWordsCampaignEntityData.removeAdwordsCampaign.bind(AdWordsCampaignEntityData, opts), 'ADWORDS_CAMPAIGN_ENTITY_REMOVE', {
        dispatch,
        startParams: opts,
        failParams: opts,
        transform: adWordsCampaignEntityTransform,
        success: () => {
          dispatch({
            type: Actions.ADWORDS_CAMPAIGN_ENTITY_REMOVE_SUCCEEDED,
            payload: opts
          });
          dispatchResetState();
        }
      });
    };
  }

};